<template>
  <div class="row">
    <div class="col-12">
      <template v-if="!isAddNewRow">
        <div class="table-header">
          <div class="table-header__titles">
            <div class="up">Всего</div>
            <div class="down">{{ getFullCount(nestedTableData) }}</div>
          </div>

          <i class="spacer" />

          <div class="table-header__buttons">
            <button
              v-hidden="`${containerType}-waste-area:edit ${containerType}-waste-area:add`"
              type="button"
              class="table-header__button add-button"
              @click="onAddNewRow()"
            >
              Добавить
            </button>
          </div>
        </div>
        <div class="table-body">
          <table>
            <thead>
              <tr>
                <th v-for="(column, index) in tableColumns" :key="`table-column-${index}`">
                  <span class="text">{{ column.name }}</span>
                </th>
                <th class="table-actions">
                  <span>&nbsp;</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, nestedTableIndex) in nestedTableData">
                <tr v-if="!row.isDelete" :key="`nested-table-${nestedTableIndex}`">
                  <td v-for="(column, tableColumnIndex) in tableColumns" :key="tableColumnIndex">
                    <div v-if="typeof row[column.key] === 'undefined'">&nbsp;</div>
                    <span v-if="column.joinedArrayBySubfield">
                      {{ row[column.key].map(item => item[column.subfield]).join(", ") }}
                    </span>
                    <span v-if="column.dir">{{ getKey(row, column) }}</span>
                    <span v-if="column.simple">{{ row[column.key] }}</span>
                    <span v-if="column.date">
                      {{ row[column.date[0]] | monthYearDate }} - {{ row[column.date[1]] | monthYearDate }}
                    </span>
                    <span v-if="column.simple_date">{{ row[column.key] | simpleDate }}</span>
                    <span v-if="column.simple_multi_date">
                      {{ row[column.multi_date[0]] | simpleDate }} - {{ row[column.multi_date[1]] | simpleDate }}
                    </span>
                    <span v-if="column.multiformat">{{ getMultiFormat(row, column) }}</span>
                  </td>
                  <td class="table-actions">
                    <button
                      v-if="!disableReduct"
                      v-hidden-inline-block="`${containerType}-waste-area:edit ${containerType}-waste-area:add`"
                      type="button"
                      class="edit-button"
                      @click="onRedactContainer(row)"
                    />
                    <button
                      v-hidden-inline-block="`${containerType}-waste-area:edit ${containerType}-waste-area:add`"
                      type="button"
                      class="delete-button"
                      @click="onDeleteContainer(row, nestedType)"
                    />
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>

      <div v-show="isAddNewRow" class="col-12">
        <div class="row">
          <div class="col-6">
            <div class="row">
              <div v-for="(element, index) in elements" :key="`element-${index}`" class="col-6">
                <div v-if="element.elementType === 'FormPlaceholder'"></div>
                <form-multi-select
                  v-if="element.elementType === 'FormMultiSelect'"
                  :value="element.value"
                  :fieldname="element.fieldname"
                  :label="element.label"
                  :keymonitor="keymonitor"
                  rest-api="/api/waste_sources"
                  @update="update"
                />
                <form-simple-date
                  v-if="element.elementType === 'FormSimpleDate'"
                  :input-model="element.value"
                  :fieldname="element.fieldname"
                  :label="element.label"
                  :placeholder="element.placeholder"
                  :error="element.error"
                  :keymonitor="keymonitor"
                  :error-info="element.errorInfo"
                  @update="update"
                />
                <form-multi-date
                  v-if="element.elementType === 'FormMultiDate'"
                  :fieldname="element.fieldname"
                  :start-date="element.value.startDate"
                  :end-date="element.value.endDate"
                  :label="element.label"
                  :error-start="element.errors.startDate"
                  :error-end="element.errors.endDate"
                  :keymonitor="keymonitor"
                  :error-info="element.errorInfo"
                  @update="update"
                />
                <form-data
                  v-if="element.elementType === 'FormData' && element.fieldname.includes('quantity')"
                  v-show="isAddingMode"
                  :input-model="element.value"
                  :fieldname="element.fieldname"
                  :label="element.label"
                  :placeholder="element.placeholder"
                  :check-input="element.checkInput"
                  :error="element.error"
                  :keymonitor="keymonitor"
                  :error-info="element.errorInfo"
                  :bottom-info="element.bottomInfo"
                  :tag-type="element.tagType"
                  @update="update"
                />
                <form-data
                  v-if="element.elementType === 'FormData' && !element.fieldname.includes('quantity')"
                  :input-model="element.value"
                  :fieldname="element.fieldname"
                  :label="element.label"
                  :placeholder="element.placeholder"
                  :check-input="element.checkInput"
                  :error="element.error"
                  :keymonitor="keymonitor"
                  :error-info="element.errorInfo"
                  :bottom-info="element.bottomInfo"
                  :tag-type="element.tagType"
                  @update="update"
                />
                <form-select
                  v-if="element.elementType === 'FormSelect'"
                  :input-model="element.value"
                  :fieldname="element.fieldname"
                  :label="element.label"
                  :input-options="element.inputOptions"
                  :two-level-update="update"
                  :two-level="element.twoLevel"
                  :keymonitor="keymonitor"
                  :subtitution="element.subtitution"
                  @update="update"
                />
                <form-checkbox
                  v-if="element.elementType === 'FormCheckbox'"
                  :value-modal="element.value"
                  :fieldname="element.fieldname"
                  :two-level-update="update"
                  :label="element.label"
                  :input-options="element.inputOptions"
                  :two-level="element.twoLevel"
                  @update="update"
                />
              </div>
              <template v-for="(element, index) in elements">
                <div v-if="element.elementType === 'FormSelectList'" :key="index" class="col-12">
                  <form-select-list
                    v-if="element.elementType === 'FormSelectList'"
                    :input-model="element.value"
                    :input-options="owners"
                    :fieldname="element.fieldname"
                    :label="element.label"
                    :on-add-list-elem="onAddListElem"
                    :container-type="containerType"
                    list-item-head="Собственник"
                    @update="update"
                  />
                </div>
              </template>
            </div>
          </div>
          <template v-for="(element, index) in elements">
            <div v-if="enableImages && element.elementType === 'ContainerImage'" :key="index" class="col-6">
              <container-image
                :fieldname="element.fieldname"
                :value="element.value"
                :container-type="containerType"
                @update="update"
              />
            </div>
          </template>
          <container-stats
            v-if="wasteSourceModifierPluginIsActive && isEditMode && editableContainerId !== null && nestedType === 'containers'"
            :container-id="editableContainerId"
          />
        </div>
      </div>

      <right-menu
        v-if="isRightMenuActive"
        :active="isRightMenuActive"
        :close="closeRightMenu"
        :slide-element-url="slideElement.slideElementUrl"
        :active-list="nestedTableData"
        :fieldname="slideElement.fieldname"
        :list-keys="slideElement.listKeys"
        @update="update"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import FormData from "../forms/FormData";
import FormSelect from "../forms/FormSelect";
import FormCheckbox from "../forms/FormCheckbox";
import FormMultiDate from "../forms/FormMultiDate";
import FormSimpleDate from "../forms/FormSimpleDate";
import FormMultiSelect from "../forms/FormMultiSelect";
import ContainerImage from "../ContainerImage";
import FormSelectList from "../forms/FormSelectList";
import ContainerStats from "../ContainerStats";

import RightMenu from "./RightMenu";

export default {
  name: "NestedContainer",
  components: {
    FormData,
    FormSelect,
    FormCheckbox,
    FormMultiDate,
    FormMultiSelect,
    FormSimpleDate,
    ContainerImage,
    RightMenu,
    FormSelectList,
    ContainerStats
  },
  props: {
    headerTitle: {
      type: String,
      default: ""
    },
    nestedType: {
      type: String,
      default: ""
    },
    containerCount: {
      type: String,
      default: ""
    },
    slideElementUrl: {
      type: [String, Boolean],
      default: false
    },
    tableColumns: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    elements: {
      type: Array,
      default: () => []
    },
    owners: {
      type: Array,
      default: () => []
    },
    beforeChangeHeader: {
      type: Function,
      default: () => ({})
    },
    update: {
      type: Function,
      default: () => ({})
    },
    onAddListElem: {
      type: Function,
      default: () => ({})
    },
    onDeleteContainer: {
      type: Function,
      default: () => ({})
    },
    keymonitor: {
      type: Function,
      default: () => ({})
    },
    enableImages: {
      type: Boolean,
      default: false
    },
    disableReduct: {
      type: Boolean,
      default: false
    },
    slideElement: {
      type: [Boolean, Object],
      default: false
    }
  },
  data() {
    return {
      isAddNewRow: false,
      isEditMode: false,
      isAddingMode: false,
      isRightMenuActive: false,
      containerType: "",
      editableContainerId: null,
      wasteSourceModifierPluginIsActive: process.env.VUE_APP_WASTE_SOURCE_MODIFIER_PLUGIN === "true"
    };
  },
  computed: {
    nestedTableData() {
      return this.tableData.map(s => {
        s.own_id = s.own_id || Math.random();
        return s;
      });
    }
  },
  mounted() {
    this.containerType = this.$route.params.containerType;
    this.$root.$on("nestedContainerDefault", () => {
      this.isAddNewRow = false;
    });
    this.$root.$on("nestedContainerAdd", () => {
      this.isAddNewRow = true;
    });
  },
  beforeDestroy() {
    this.$root.$off("nestedContainerDefault");
    this.$root.$off("nestedContainerAdd");
  },
  methods: {
    ...mapActions(["getSource"]),
    getFullCount(data) {
      if (this.containerCount.length === 0) {
        return data.length;
      }
      const count = data.reduce((acc, curr) => {
        const contCount = Number(curr[this.containerCount]);
        if (contCount > 0) {
          return acc + contCount;
        }
        return acc + 1;
      }, 0);
      return count;
    },
    onAddNewRow(elem, mode = "Adding") {
      this.isEditMode = false;
      this.isAddingMode = false;

      if (this.slideElement) {
        this.isRightMenuActive = true;
      } else {
        this.isAddNewRow = !this.isAddNewRow;
        this.beforeChangeHeader(elem, this.headerTitle, this.nestedType);
      }

      this[`is${mode}Mode`] = true;
    },
    onRedactContainer(elem) {
      this.onAddNewRow(elem, "Edit");

      this.editableContainerId = elem.id ? elem.id : null;
    },
    getKey(row, column) {
      const value = row[column.key];
      const elem = column.dir.find(s => s.value === value);

      if (elem) {
        return elem.text;
      }
      return "–";
    },
    getMulti(row, column) {
      return `${row[column.type[0]]} - ${row[column.type[0]]}`;
    },
    closeRightMenu() {
      this.isRightMenuActive = !this.isRightMenuActive;
    },
    getMultiFormat(row, column) {
      const dic = column.multiDic;
      const items = row[column.key];
      let elems = "";

      items.map(s => {
        const findElem = dic.find(l => l.value === s);
        if (findElem) {
          elems = `${findElem.text}, `;
        }
      });

      return elems.slice(0, elems.length - 2);
    }
  }
};
</script>
